import { type FC, useCallback } from 'react';
import { useApproveImportJobMutation } from 'pages/objectManager/components/import/api/importObjectsApi';
import { type TObjectImportJob } from 'types/objectJob.type';
import { getErrorMessage } from 'utils/errorUtils';
import { errorNotification } from 'utils/notifications';
import { Button, Icon } from '@timeedit/ui-components';
import { Popconfirm } from '@timeedit/ui-components/antd';
import ImportResult from './ImportResult';
import JobDetailHeader from './JobDetailHeader';
import OperationInfo from './OperationInfo';
import ValidationResult from './ValidationResult';

type Props = {
  data: TObjectImportJob;
};

const ImportDetails: FC<Props> = ({ data }: Props) => {
  const [approveImportJob] = useApproveImportJobMutation();

  const handleApproveImportJob = useCallback(async () => {
    const result = await approveImportJob({ jobId: data._id });

    if (result.error) {
      errorNotification('Failed to start import job', [
        getErrorMessage(result.error),
      ]);
    }
  }, [approveImportJob, data._id]);

  return (
    <>
      <JobDetailHeader
        job={data}
        newOperationButton={
          <Popconfirm
            title="Are you sure you ant to import the objects?"
            icon={<Icon id="Warning" alt="" style={{ paddingRight: '4px' }} />}
            onConfirm={handleApproveImportJob}
            okText="Import"
          >
            <Button disabled={data.status !== 'PENDING_REVIEW'} type="primary">
              Import objects
            </Button>
          </Popconfirm>
        }
      />
      <OperationInfo job={data} hideShowAllObjects />
      <ValidationResult job={data} />
      <ImportResult job={data} />
    </>
  );
};

export default ImportDetails;
